import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { useSetState } from '@domain-group/react-hooks'

import { Box, Button, Text } from '@domain-group/suit-theme'

import useFavouriteOrder from '@hooks/useFavouriteOrder'
import useFavouriteOrderItems from '@hooks/useFavouriteOrderItems'

import { confirmDelete } from '@functions/entity'

import type { FavouriteOrderModel } from '@models/favouriteOrder'

type DefaultState = { loading: boolean }

export type SetState = (state: Partial<DefaultState>) => void

const defaultState = {
  loading: false,
}

interface FavouriteOrderProps {
  callbacks: {
    selectFavouriteOrder: (state: SetState) => void,
  },
  favouriteOrder: FavouriteOrderModel,
}

const FavouriteOrder = (props: FavouriteOrderProps) => {
  const {
    callbacks: {
      selectFavouriteOrder,
    },
    favouriteOrder: {
      id,
      total,
    },
  } = props

  const [state, setState] = useSetState(defaultState)
  const { loading } = state

  const { callbacks: { deleteFavouriteOrder: deleteFn } } = useFavouriteOrder({ id })

  const favouriteOrderItemsPayload = useFavouriteOrderItems({
    filters: {
      favourite_order_id: id,
    },
  })

  const { filteredFavouriteOrderItems } = favouriteOrderItemsPayload
  const firstItem = filteredFavouriteOrderItems[0]

  if (!firstItem) return null

  const { options_string, title } = firstItem

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This Order will not longer appear in favourites.',
      deleteString: 'Remove',
      entityName: 'Favourite Order',
    },
  }

  return (
    <Box
      alignItems="center"
      border="1px dashed"
      borderColor="lineColor"
      borderRadius="5px"
      flexDirection="column"
      marginTop="medium"
      padding="large"
    >
      <Box>
        <Box justifyContent="center" flexDirection="column" width="calc(100% - 166px)">
          <Text fontSize="small" lineHeight="1.3">
            {title}
          </Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
            {options_string || 'No Options'}
          </Text>
        </Box>

        <Box alignItems="center" justifyContent="flex-end" marginLeft="auto" width={150}>
          <Text color="bodyFontLightColor" fontSize="small" marginRight="large">
            {formatMoney(total)}
          </Text>

          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            loading={loading}
            onClick={() => {
              setState({ loading: true })
              selectFavouriteOrder(setState)
            }}
            size="small"
            // @ts-expect-error
            width="auto"
          >
            Add
          </Button>

          <Button
            buttonStyle="secondaryUtility"
            // @ts-expect-error
            height="30px"
            icon={<FontAwesomeIcon icon={faTrashAlt} />}
            marginLeft="small"
            // @ts-expect-error TS2345
            onClick={() => confirmDelete(confirmDeletePayload)}
            padding="medium"
            width="auto"
          />
        </Box>
      </Box>
    </Box>
  )
}

export default FavouriteOrder
